import { render, staticRenderFns } from "./pdf-preview.vue?vue&type=template&id=82bc787e&scoped=true&"
import script from "./pdf-preview.vue?vue&type=script&lang=js&"
export * from "./pdf-preview.vue?vue&type=script&lang=js&"
import style0 from "./pdf-preview.vue?vue&type=style&index=0&id=82bc787e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bc787e",
  null
  
)

export default component.exports